import React, { useState } from 'react';
import { tabs } from './my-bookshelf/constants';
import { useBookshelfState } from './my-bookshelf/useBookshelfState';
import { BookHoverCard } from './my-bookshelf/BookHoverCard';
import { BookshelfToolbar } from './my-bookshelf/BookshelfToolbar';
import { OwnedShelfView } from './my-bookshelf/OwnedShelfView';
import { StatusTabView } from './my-bookshelf/StatusTabView';
import { BookDetailModal } from './my-bookshelf/BookDetailModal';
import { useDarkClasses } from '../hooks/useDarkClasses';
import { useRoleTheme } from '../hooks/useRoleTheme';
import { PackageIcon, ExternalLinkIcon, UploadCloudIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
interface PersonalBookData {
  userRating: number;
  status: string;
  dateRead: string;
  notes: string;
  formatOwned: string;
}
export default function ReaderVirtualBookshelf() {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const {
    books,
    activeTab,
    searchTerm,
    selectedGenre,
    selectedSubgenre,
    selectedRelationship,
    selectedFormat,
    viewMode,
    darkMode,
    sortOption,
    seriesFilter,
    showFilters,
    selectedAuthor,
    hoveredBookId,
    isEditMode,
    selectedBooks,
    mousePosition,
    setSearchTerm,
    setSelectedGenre,
    setSelectedSubgenre,
    setSelectedRelationship,
    setSelectedFormat,
    setViewMode,
    setSortOption,
    setSeriesFilter,
    setShowFilters,
    setSelectedAuthor,
    setHoveredBookId,
    authors,
    genres,
    subgenres,
    relationshipTypes,
    formats,
    filteredBooks,
    sortedBooks,
    seriesData,
    handleTabChange,
    toggleEditMode,
    toggleBookSelection,
    selectAllBooks,
    clearSelection,
    bulkChangeStatus,
    bulkDelete,
    navigateToBookDetail,
    handleDragStart,
    handleDragEnter,
    handleDragEnd
  } = useBookshelfState();
  // Modal state
  const [modalBook, setModalBook] = useState<any | null>(null);
  const [personalData, setPersonalData] = useState<Record<string, PersonalBookData>>({});
  const navigate = useNavigate();
  const handleCardClick = (book: any) => {
    setModalBook(book);
  };
  const handleSavePersonalData = (bookId: string, data: PersonalBookData) => {
    setPersonalData(prev => ({
      ...prev,
      [bookId]: data
    }));
  };
  // Mock Merch Data
  const mockMerchCollection = [{
    id: 'm1',
    title: 'Fantasy Realms Bookmark Set',
    creator: 'Bookish Designs Co.',
    category: 'Bookmarks',
    image: 'https://images.unsplash.com/photo-1544947987-f6c4fa25fa4a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    fandom: 'The Silent Echo'
  }, {
    id: 'm2',
    title: 'Midnight Shadows Tote Bag',
    creator: 'Canvas & Co.',
    category: 'Apparel',
    image: 'https://images.unsplash.com/photo-1597484661643-2f5fef640df1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    fandom: 'Midnight Chronicles'
  }, {
    id: 'm3',
    title: 'Elements Trilogy Map Print',
    creator: 'Cartography Arts',
    category: 'Prints',
    image: 'https://images.unsplash.com/photo-1524661135-423995f22d0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    fandom: 'Elements Trilogy'
  }, {
    id: 'm4',
    title: 'Dragon Scale Enamel Pin',
    creator: 'Pin Makers',
    category: 'Accessories',
    image: 'https://images.unsplash.com/photo-1611652022419-a9419f74343d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    fandom: 'Epic Fantasy'
  }];
  const merchCategories = ['Apparel', 'Prints', 'Home', 'Bookmarks', 'Accessories'];
  return <div className={`min-h-screen pt-4 pb-8 ${dk.page}`} data-id="element-10550" data-mp="30sb8xz4ye1y0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10551" data-mp="2wpojg4vr8t3z">
        <div className="mb-6 flex flex-col sm:flex-row sm:justify-between sm:items-end gap-4" data-id="element-10552" data-mp="yylm2wx89jow">
          <div data-id="element-10553" data-mp="uxjlocrkr1lc">
            <h1 className={`text-2xl font-bold ${dk.textHeading}`} data-id="element-10554" data-mp="uwql5tj7l8bn">
              My Virtual Bookshelf
            </h1>
            <p className={`mt-1 text-sm ${dk.textSecondary}`} data-id="element-10555" data-mp="121rt69wl44uf">
              Organize and showcase your indie books with full control
            </p>
          </div>
          <button onClick={() => navigate('/my-bookshelf/import')} className={`flex items-center px-4 py-2 rounded-lg text-sm font-medium transition-colors border ${darkMode ? 'border-indigo-500 text-indigo-400 hover:bg-indigo-900/30' : 'border-indigo-200 bg-indigo-50 text-indigo-700 hover:bg-indigo-100'}`} data-id="element-10556" data-mp="t0206zn20xuj">
            <UploadCloudIcon className="w-4 h-4 mr-2" data-id="element-10557" data-mp="o29zph8cg3eq" />
            Import Library
          </button>
        </div>

        {/* Status Tabs */}
        <div className={`mb-4 flex space-x-4 overflow-x-auto border-b ${dk.border}`} style={{
        scrollbarWidth: 'none'
      }} data-id="element-10558" data-mp="eavv4v1jcdeq">
          <div className="flex space-x-4 px-1 min-w-max" data-id="element-10559" data-mp="d7jmdtcyimc">
            {tabs.map(tab => <button key={tab.id} onClick={() => handleTabChange(tab.id)} className={`py-2 px-4 font-medium whitespace-nowrap transition-colors ${activeTab === tab.id ? `border-b-2 ${rt.borderAccent} ${rt.textPrimary}` : `${dk.textMuted} hover:${rt.textPrimary}`}`} data-id="element-10560" data-mp="59ee9agb07oz">
                {tab.label}
              </button>)}
          </div>
        </div>

        {/* Author Tabs — hidden on mobile (accessible via filter panel) */}
        <div className={`mb-4 overflow-x-auto hidden md:block ${dk.textSecondary}`} style={{
        scrollbarWidth: 'none'
      }} data-id="element-10561" data-mp="4l723581p4zz">
          <div className="flex space-x-2 px-1 min-w-max" data-id="element-10562" data-mp="ebrz4o82m1gs">
            {authors.map(author => <button key={author} onClick={() => setSelectedAuthor(author)} className={`py-1 px-3 rounded-full text-sm whitespace-nowrap transition-colors ${selectedAuthor === author ? `${rt.bgMedium} ${rt.textPrimary}` : dk.badgeNeutral}`} data-id="element-10563" data-mp="9fb89m9hl900">
                {author === 'all' ? 'All Authors' : author}
              </button>)}
          </div>
        </div>

        {/* Toolbar */}
        {activeTab !== 'merch' && <BookshelfToolbar darkMode={darkMode} searchTerm={searchTerm} setSearchTerm={setSearchTerm} selectedGenre={selectedGenre} setSelectedGenre={setSelectedGenre} genres={genres} selectedSubgenre={selectedSubgenre} setSelectedSubgenre={setSelectedSubgenre} subgenres={subgenres} selectedRelationship={selectedRelationship} setSelectedRelationship={setSelectedRelationship} relationshipTypes={relationshipTypes} viewMode={viewMode} setViewMode={setViewMode} activeTab={activeTab} showFilters={showFilters} setShowFilters={setShowFilters} sortOption={sortOption} setSortOption={setSortOption} seriesFilter={seriesFilter} setSeriesFilter={setSeriesFilter} selectedFormat={selectedFormat} setSelectedFormat={setSelectedFormat} formats={formats} isEditMode={isEditMode} toggleEditMode={toggleEditMode} selectedBooks={selectedBooks} clearSelection={clearSelection} selectAllBooks={selectAllBooks} bulkChangeStatus={bulkChangeStatus} bulkDelete={bulkDelete} data-id="element-10564" data-mp="3l6je6pu1xmwj" />}

        {/* Content Views */}
        {activeTab === 'merch' ? <div className="space-y-8 mt-6" data-id="element-10565" data-mp="2gvzwreizg43l">
            {merchCategories.map(category => {
          const items = mockMerchCollection.filter(m => m.category === category);
          if (items.length === 0) return null;
          return <div key={category} data-id="element-10566" data-mp="10ihy5elnpiv4">
                  <h3 className={`text-lg font-bold mb-4 flex items-center gap-2 ${dk.textHeading}`} data-id="element-10567" data-mp="10lnoex60uqsf">
                    <PackageIcon className="h-5 w-5 text-indigo-500" data-id="element-10568" data-mp="34o76q4481vte" />
                    {category}
                  </h3>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4" data-id="element-10569" data-mp="2qoxrp7rr57r0">
                    {items.map(item => <div key={item.id} className={`rounded-xl border overflow-hidden flex flex-col ${dk.card} ${dk.border}`} data-id="element-10570" data-mp="3jcag7nhh3pmy">
                        <div className="aspect-square relative overflow-hidden bg-gray-100 dark:bg-gray-800" data-id="element-10571" data-mp="39mik2otq6ogd">
                          <img src={item.image} alt={item.title} className="w-full h-full object-cover" data-id="element-10572" data-mp="3ekjz8yo163mk" />
                        </div>
                        <div className="p-3 flex flex-col flex-grow" data-id="element-10573" data-mp="axjnv8t2y2i4">
                          <h4 className={`font-semibold text-sm line-clamp-2 mb-1 ${dk.textPrimary}`} data-id="element-10574" data-mp="1vlm58kpqthzv">
                            {item.title}
                          </h4>
                          <p className={`text-xs mb-2 ${dk.textSecondary}`} data-id="element-10575" data-mp="24e68jygzcar1">
                            by {item.creator}
                          </p>
                          <div className="mt-auto pt-2 border-t border-gray-100 dark:border-gray-800" data-id="element-10576" data-mp="1cn01ey2udcs9">
                            <span className={`text-[10px] font-medium uppercase tracking-wider text-indigo-500`} data-id="element-10577" data-mp="17pgk1paukjw3">
                              {item.fandom}
                            </span>
                          </div>
                        </div>
                      </div>)}
                  </div>
                </div>;
        })}
          </div> : activeTab === 'ownedShelf' ? <OwnedShelfView darkMode={darkMode} seriesFilter={seriesFilter} viewMode={viewMode} isEditMode={isEditMode} filteredBooks={filteredBooks} seriesData={seriesData} selectedBooks={selectedBooks} toggleBookSelection={toggleBookSelection} navigateToBookDetail={navigateToBookDetail} onCardClick={handleCardClick} setHoveredBookId={setHoveredBookId} handleDragStart={handleDragStart} handleDragEnter={handleDragEnter} handleDragEnd={handleDragEnd} data-id="element-10578" data-mp="q5e2l1p9jyxi" /> : <StatusTabView darkMode={darkMode} viewMode={viewMode} isEditMode={isEditMode} sortedBooks={sortedBooks} selectedBooks={selectedBooks} toggleBookSelection={toggleBookSelection} navigateToBookDetail={navigateToBookDetail} onCardClick={handleCardClick} setHoveredBookId={setHoveredBookId} handleDragStart={handleDragStart} handleDragEnter={handleDragEnter} handleDragEnd={handleDragEnd} data-id="element-10579" data-mp="3tm4oyr55kold" />}

        {/* Hover Card (spine view only) */}
        {hoveredBookId && !isEditMode && viewMode === 'spine' && (() => {
        const hoveredBook = books.find(book => book.id === hoveredBookId);
        return hoveredBook ? <BookHoverCard book={hoveredBook} darkMode={darkMode} mousePosition={mousePosition} data-id="element-10580" data-mp="2rqqg0sle9kvk" /> : null;
      })()}
      </div>

      {/* My Copy Modal */}
      {modalBook && <BookDetailModal book={modalBook} darkMode={darkMode} personalData={personalData[modalBook.id] ?? {
      userRating: 0,
      status: modalBook.status || 'tbr',
      dateRead: '',
      notes: '',
      formatOwned: modalBook.format || 'paperback'
    }} onSave={handleSavePersonalData} onClose={() => setModalBook(null)} onNavigate={id => {
      navigateToBookDetail(id);
      setModalBook(null);
    }} data-id="element-10581" data-mp="30szs3mwb9mb2" />}
    </div>;
}